import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { httpClient } from "settings/apolloClient";
import PLANT_LOCATIONS_QUERY from "views/InstrumentsPanel/graphql/queries/plantLocations";
import ActuatorStatusSubscriber from "./ActuatorStatusSubscriber.jsx";

// Runs the per-actuator status subscriptions once for the whole session, from the
// Admin layout, so navigating between pages never tears them down and re-triggers
// the @absinthe/socket resubscribe race that froze actuator status after a tab
// switch. Actuator status is shipment-independent, so this queries with
// concreteShipmentId 0 purely to enumerate ids; each subscription patches the
// normalized Actuator entity that the panel's own PLANT_LOCATIONS query reads.
const ActuatorStatusSubscribersHost = () => {
  const { data } = useQuery(PLANT_LOCATIONS_QUERY, {
    fetchPolicy: "cache-and-network",
    client: httpClient,
    variables: { concreteShipmentId: 0 },
  });

  const devices = (data && data.devices) || [];
  const actuatorIds = devices
    .reduce((locations, device) => locations.concat(device.plantLocations || []), [])
    .reduce((actuators, location) => actuators.concat(location.actuators || []), [])
    .map(actuator => actuator.id);

  if (!actuatorIds.length) return null;

  return (
    <React.Fragment>
      {actuatorIds.map(id => <ActuatorStatusSubscriber key={id} id={id} />)}
    </React.Fragment>
  );
};

export default ActuatorStatusSubscribersHost;
